import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import moment from "moment";
import Icon from "module-common/Icon";
import Avatar from "module-common/Avatar";
import LabelList from "module-common/label-list/LabelList";
import { Button } from "antd";

export default class Row extends Component {
  
  render() {

    const {
      id,
      index,
      campaignType,
      campaignStatus,
      sendStatus,
      settings,
      recipient,
      onEdit
    } = this.props;

    return (
      <Wrapper>
        <Index>{index}.</Index>
        <Name>
            {recipient.name}. {settings.title}<br />
            {campaignStatus == 'sent' && `Sent at ${sendStatus.sendTime} to ${sendStatus.sendCount} recipient`}
            {campaignStatus == 'sending' && `Sending to ${recipient.recipientCount} recipient`}
            {campaignStatus == 'save' && 'saved as draft'}
        </Name>
        <Name>
          {campaignStatus == 'sent' && 'Sent'}
          {campaignStatus == 'sending' && 'Sending..'}
          {campaignStatus == 'save' && 'Draft'}
        </Name>
        <Toolbox>
          {campaignStatus == 'save' && <Button onClick={() => onEdit(this.props)}>Edit</Button>}
        </Toolbox>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  width: auto;
  height: auto;
  display: flex;
  flex: none;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
  align-items: center;
  padding: 10px;
  &:hover {
    background: #ececec;
    font-weight: 600;
    cursor: pointer;
  }
`;

const Index = styled.div`
  margin-left: 10px;
  flex: 1;
`;

const Name = styled.div`
  flex: 4;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledAvatar = styled(Avatar)`
  margin-right: 10px;
`;

const Toolbox = styled.div`
  flex: 3;
`;

const IconSocial = styled(Icon)`
  flex: 2;
`;

const Label = styled.div`
  flex: 4;
  margin-right: 10px;
`;



// WEBPACK FOOTER //
// ./src/module-email-campaign/campaign/Row.js